module.exports = __webpack_public_path__ + "static/media/marco.21db285d.png";